import React from 'react';
import { Box, Typography } from '@mui/material';
import { MailOutline as MailOutlineIcon, PersonOutline as PersonOutlineIcon } from '@mui/icons-material';

// Adresse mail déplaçable (« Informations du formulaire », admin et admin Legrand) : on l'attrape à la souris et on la
// dépose ailleurs (champ destinataire d'un mail, autre application…).

interface Props {
  email: string;
  // Mail du client de la demande : icône personne et infobulle dédiée
  client?: boolean;
}

const AdresseGlissable: React.FC<Props> = ({ email, client = false }) => {
  const handleDragStart = (event: React.DragEvent<HTMLSpanElement>) => {
    event.dataTransfer.setData('text/plain', email);
    event.dataTransfer.setData('text/uri-list', `mailto:${email}`);
    event.dataTransfer.effectAllowed = 'copy';
  };

  const Icone = client ? PersonOutlineIcon : MailOutlineIcon;

  return (
    <Box
      component="span"
      draggable
      onDragStart={handleDragStart}
      title={client ? 'Mail du client : glissez cette adresse où vous voulez' : 'Glissez cette adresse où vous voulez'}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1,
        py: 0.5,
        borderRadius: 1,
        cursor: 'grab',
        userSelect: 'none',
        '&:hover': { bgcolor: '#f0f0f0' },
        '&:active': { cursor: 'grabbing' },
      }}
    >
      <Icone fontSize="small" sx={{ color: 'text.secondary' }} />
      <Typography component="span" variant="body2" sx={{ wordBreak: 'break-all' }}>
        {email}
      </Typography>
    </Box>
  );
};

export default AdresseGlissable;
